let tabbableEls = null
let currentFocusIndex = 0

function getTabbableEls(container, exclude = []) {
  const treeWalker = document.createTreeWalker(
    container,
    NodeFilter.SHOW_ELEMENT,
    {
      acceptNode: function (node) {
        return node.tabIndex >= 0
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP
      },
    },
    false
  )
  const tabbable = []
  let currNode = null
  while ((currNode = treeWalker.nextNode())) {
    if (!currNode.disabled && !exclude.includes(currNode)) {
      tabbable.push(currNode)
    }
  }

  return tabbable
}

function advance() {
  let next = currentFocusIndex + 1
  if (next > tabbableEls.length - 1) {
    next = 0
  }
  currentFocusIndex = next
  tabbableEls?.[next]?.focus()
}

function retreat() {
  let next = currentFocusIndex - 1
  if (next < 0) {
    next = tabbableEls.length - 1
  }
  currentFocusIndex = next
  tabbableEls?.[next]?.focus()
}

function handleKeydown(evt) {
  const keyList = ["Tab", "ArrowDown", "ArrowUp"]

  if (
    keyList.includes(evt.code) &&
    !evt.ctrlKey &&
    !evt.altKey &&
    !evt.metaKey
  ) {
    evt.preventDefault()

    if ((evt.code === "Tab" && evt.shiftKey) || evt.code === "ArrowUp") {
      retreat()
    } else {
      advance()
    }
  }
}

function updateTabbableEls(el, exclude = []) {
  tabbableEls = getTabbableEls(el, exclude)
}

function trapFocus(el, exclude = []) {
  updateTabbableEls(el, exclude)
  currentFocusIndex = 0

  tabbableEls[0].focus()

  document.addEventListener("keydown", handleKeydown)
}

function releaseFocus(newFocusEl) {
  document.removeEventListener("keydown", handleKeydown)
  tabbableEls = null
  currentFocusIndex = 0
  if (newFocusEl) newFocusEl.focus()
}
